module.exports = __webpack_public_path__ + "fb51117ddaef555eab86467fe36952f2.svg";